import useLocation, { HookedLocation } from 'hooks/useLocation';
import { isFunction, isString } from 'lodash';
import { useEffect } from 'react';

import { Touchable } from '@skippay/core/@types/touchable';

interface Props {
	/**
	 * Three possible types could be passed
	 *
	 * - string: proxies all parameters (`query`, `hash` and `state`) and uses string as `pathname`.
	 * - object: is used as is, do not proxy any arguments.
	 * - function: will receive current location and any other props (e.g. match params when used in Router) and must
	 * 	return `to` as an object, which will be used as is, do not proxy any arguments.
	 */
	to:
		| Touchable['to']
		| ((
				props: Omit<Props, 'to'> & {
					defaultPrivateRoot: HookedLocation['defaultPrivateRoot'];
				} & HookedLocation['location']
		  ) => Touchable['to']);
	path?: string;
	query?: Record<string, unknown>;
}

function Redirect(props: Props): null {
	const { to, ...other } = props;
	const { defaultPrivateRoot, history, location } = useLocation();

	useEffect(() => {
		history?.replace(
			isString(to)
				? { ...location, pathname: to }
				: isFunction(to)
				? to({ ...other, ...location, defaultPrivateRoot })
				: to
		);
	}, []);

	return null;
}

export default Redirect;
